import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../../components/iconify';

const BOTTOM_NAV_HEIGHT = 64;

const PRIMARY_ITEMS = {
  ADMIN: [
    { label: 'Statistika', icon: 'mdi:chart-line', path: '/dashboard/app' },
    { label: 'Mijozlar', icon: 'mdi:account-group-outline', path: '/dashboard/clients' },
    { label: 'Sotuvchilar', icon: 'mdi:store-outline', path: '/dashboard/vendors' },
    { label: 'Mahsulot', icon: 'mdi:cart-outline', path: '/dashboard/products' },
    { label: 'Boshqa', icon: 'mdi:dots-horizontal', path: 'more' },
  ],
  VENDOR: [
    { label: 'Buyurtma', icon: 'mdi:shopping-outline', path: '/dashboard/orders/all', notify: 'orders' },
    { label: 'Mijozlar', icon: 'mdi:account-group-outline', path: '/dashboard/clients' },
    { label: 'Statistika', icon: 'mdi:chart-line', path: '/dashboard/app' },
    { label: 'Kuryer', icon: 'mdi:moped-outline', path: '/dashboard/couriers' },
    { label: 'Boshqa', icon: 'mdi:dots-horizontal', path: 'more' },
  ],
  COURIER: [
    { label: 'Buyurtmalar', icon: 'mdi:shopping-outline', path: '/dashboard/orders/all', notify: 'orders' },
    { label: 'Arxiv', icon: 'mdi:archive-outline', path: '/dashboard/orders/archive' },
  ],
};

export default function BottomNav({ onMore }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { role } = useSelector((state) => state.auth);
  const { ordersCount } = useSelector((state) => state.orders);

  const items = PRIMARY_ITEMS[role] || [];

  const current = items.find((item) => item.path !== 'more' && pathname.startsWith(item.path))?.path || false;

  const handleChange = (_, value) => {
    if (value === 'more') {
      if (onMore) onMore();
    } else {
      navigate(value);
    }
  };

  if (items.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        height: BOTTOM_NAV_HEIGHT,
        backgroundColor: theme.palette.common.white,
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        display: { xs: 'block', lg: 'none' },
      })}
    >
      <BottomNavigation
        value={current}
        onChange={handleChange}
        showLabels
        sx={{
          height: '100%',
          '& .MuiBottomNavigationAction-root': {
            color: 'text.secondary',
            minWidth: 0,
            padding: '6px 4px',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: 11,
            fontWeight: 500,
            mt: 0.5,
            '&.Mui-selected': { fontSize: 11 },
          },
        }}
      >
        {items.map((item) => {
          const showBadge = item.notify === 'orders' && ordersCount > 0;
          return (
            <BottomNavigationAction
              key={item.path}
              value={item.path}
              label={item.label}
              icon={
                showBadge ? (
                  <Badge
                    badgeContent={ordersCount}
                    color="error"
                    sx={(theme) => ({
                      '& .MuiBadge-badge': {
                        fontSize: 10,
                        height: 16,
                        minWidth: 16,
                        padding: '0 4px',
                        backgroundColor: theme.palette.error.main,
                        color: theme.palette.common.white,
                      },
                    })}
                  >
                    <Iconify icon={item.icon} width={22} />
                  </Badge>
                ) : (
                  <Iconify icon={item.icon} width={22} />
                )
              }
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}

export { BOTTOM_NAV_HEIGHT };
